export const posts = [
  {
  id: 4,
  title: "Real-World AWS Development Course Now Available on Skillshare",
  type: "update",
  date: "2026-03-26",
  summary: "New hands-on AWS course focused on real-world serverless architectures and practical implementation.",
  link: "aws-course-skillshare",
  image: "/images/realWorldAwsDevelopment.png"
  },
  {
  id: 5,
  title: "Expanding into AI on AWS — AWS AI Practitioner Certification",
  type: "update",
  date: "2026-03-17",
  summary: "New capabilities in AI-powered AWS solutions, including Bedrock, Textract, and automation workflows.",
  link: "/aws-ai-practitioner",
  image: "/images/awsAiPractitionerBadge.png"
  },
  {
  id: 6,
  title: "Strengthening Data Engineering on AWS — Data Engineer Associate Certification",
  type: "update",
  date: "2026-01-22",
  summary: "Expanded capabilities in AWS data pipelines, processing, and analytics-ready architectures.",
  link: "/aws-data-engineer",
  image: "/images/awsDataEngineerBadge.png"
  },
  {
  id: 7,
  title: "Real-World AWS Development Course Now Available on Udemy",
  type: "update",
  date: "2025-10-25",
  summary: "Hands-on AWS course covering serverless architecture, event-driven systems, and real-world implementation.",
  link: "/aws-course-udemy",
  image: "/images/realWorldAwsDevelopment.png"
  },
  {
  id: 8,
  title: "Building a Serverless Candidate Processing System on AWS",
  type: "case",
  date: "2025-11-29",
  summary: "Design and implementation of a scalable, serverless system for document processing and candidate data management.",
  link: "/serverless-candidate-system",
  image: "/images/recruitmentAgencyDiagram.png"
  },
  {
  id: 9,
  title: "Advancing DevOps on AWS — DevOps Engineer Professional Certification",
  type: "update",
  date: "2025-01-11",
  summary: "Expanded capabilities in CI/CD, infrastructure as code, and operating production-grade AWS systems.",
  link: "/aws-devops-professional",
  image: "/images/awsDevOpsEngineerBadge.png"
  },
  {
  id: 10,
  title: "Expanding Machine Learning on AWS — ML Specialty Certification",
  type: "update",
  date: "2024-04-21",
  summary: "Expanded capabilities in building, deploying, and integrating machine learning solutions on AWS.",
  link: "/aws-ml-specialty",
  image: "/images/awsMachineLearningBadge.png"
  },
  {
  id: 11,
  title: "Strengthening Database Expertise on AWS — Database Specialty Certification",
  type: "update",
  date: "2024-01-27",
  summary: "Expanded capabilities in designing, optimizing, and scaling database solutions on AWS.",
  link: "/aws-database-specialty",
  image: "/images/AwsDatabaseBadge.png"
  },
  {
  id: 12,
  title: "Strengthening Security on AWS — Security Specialty Certification",
  type: "update",
  date: "2023-12-02",
  summary: "Expanded capabilities in IAM, encryption, network security, and secure AWS architecture design.",
  link: "/aws-security-specialty",
  image: "/images/awsSecurityBadge.png"
  },
  {
  id: 13,
  title: "Designing Advanced AWS Architectures — Solutions Architect Professional Certification",
  type: "update",
  date: "2023-09-23",
  summary: "Advanced capabilities in designing scalable, resilient, and cost-efficient AWS architectures.",
  link: "/aws-solutions-architect-professional",
  image: "/images/awsSolutionsArchitectProfessionalBadge.png"
  },
  {
  id: 14,
  title: "Building AWS Architecture Foundations — Solutions Architect Associate Certification",
  type: "update",
  date: "2022-01-07",
  summary: "Foundation in designing scalable, reliable, and cost-efficient AWS architectures.",
  link: "/aws-solutions-architect-associate",
  image: "/images/awsSolutionsArchitectAssociate.png"
  },
  {
  id: 15,
  title: "Starting My AWS Journey — Developer Associate Certification",
  type: "update",
  date: "2021-10-08",
  summary: "The foundation of hands-on AWS development and serverless application building.",
  link: "/aws-developer-associate",
  image: "/images/AwsDeveloperBadge.png"
  }
].sort((a, b) => new Date(b.date) - new Date(a.date));